import { Helmet } from '@dr.pogodin/react-helmet';

type SSRLayout = {
    children?: React.ReactNode;
    lang: string;
};
export const SSRLayout = ({ children, lang }: SSRLayout) => {
    const language = lang ?? 'no';
    return (
        <>
            <div className="mosey-layout">
                <Helmet htmlAttributes={{ lang: language }}>
                    <meta property="og:type" content="website" />
                    <meta property="og:locale" content={language} />
                </Helmet>

                <main id="main" style={{ visibility: 'hidden' }}>
                    {children}
                </main>
            </div>
        </>
    );
};

export default SSRLayout;
